import React from 'react';
import ContractorDashboard from './ContractorDashboard';

/**
 * Create Ticket for a contractor: the standard form, in the portal's frame.
 *
 * Gordon, 22 October: "Contractors raising tickets - yes allow them to raise
 * tickets as well - they might need subscriptions or to buy things for the
 * company." This file was that form - a request to the firm, asking for a
 * title, what it was for, a category, an approver and the job it concerned,
 * and nothing a staff ticket asks.
 *
 * Gordon, 26 October: "On the contractor's view, when a contractor raises a
 * request, the request can be linked to an asset as well - why don't we have
 * the standard ticket here? It's more open." So the separate form is retired.
 * A contractor fills in pages/CreateTicket.js, which knows whose form it is
 * (lib/contractorAuth's portalContractor) and shapes itself: the requester is
 * them, read-only; there is no department and no template; the device picker
 * lists what they hold or look after and nothing else; and the job it is
 * about is still offered. What the POST carries, and the "Sent for approval"
 * page afterwards, are exactly as before - a request is still a request
 * (migration 064) and goes through the firm's approval unchanged.
 *
 * Drawn in the portal's frame - the strip above it, as Assets and Docs are
 * (ContractorDashboard's 'create' pane) - so raising a request looks like
 * the rest of the portal rather than a page the contractor has left it for.
 * /create keeps its address, and ?title=, ?description= and ?asset= from My
 * Equipment's "Report a problem" and "This is not mine" still arrive here.
 *
 * `props` are the portal's own (assetsForContractors, docsForContractors):
 * which optional tabs the strip shows, which App.js already knows.
 */
export default function ContractorCreateTicket(props) {
  return <ContractorDashboard tab="create" {...props} />;
}
